import { render, staticRenderFns } from "./otherTool.html?vue&type=template&id=cd4b70ba&scoped=true&"
import script from "./otherTool.js?vue&type=script&lang=js&"
export * from "./otherTool.js?vue&type=script&lang=js&"
import style0 from "./otherTool.scss?vue&type=style&index=0&id=cd4b70ba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd4b70ba",
  null
  
)

export default component.exports